<template>
  <div>
    <in-view
      class="startpage-recipegroup__buttons slide-into-view-transition"
      :threshold="0"
      :threshold-type="'px'"
    >
      <!-- BUTTON LIST -->
      <button
        v-for="(item, index) in recipeGroupContentArea"
        :key="`${index}-key`"
        :class="[activeRecipeGroup && activeRecipeGroup.title === item.title ? 'button--active' : 'button--white', $root.isSmallViewport ? 'button--32' : 'button--40']"
        type="button"
        class="button startpage-recipegroup__button"
        @click="changeRecipeGroup(index, item.title)"
      >
        {{ item.title }}
      </button>
    </in-view>

    <!-- RECIPES -->
    <block-grid
      v-if="activeRecipeGroup"
      :blocks="activeRecipeGroup.recipes"
      :custom-size="fixedSizes"
      :tracking="{
        listName: trackingListName,
        listLength: String(activeRecipeGroup.recipes.length)
      }"
      @open-folder-modal="openFolderModal"
    />
    <link-wrapper
      v-if="activeRecipeGroup"
      ref="linkWrapperRef"
      class="startpage-recipegroup__link"
      :url="activeRecipeGroup.url"
      :title="activeRecipeGroup.buttonLabel ? activeRecipeGroup.buttonLabel : 'Se fler recept (' + activeRecipeGroup.title + ')'"
      :tracking="{
        event: 'callToActionSelect'
      }"
    />
  </div>
</template>

<script>
import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'
import dataLayer from '@/analytics/dataLayer'

export default {
  name: "ReceptVirtualGroupBlock",
  components: {
    linkWrapper
  },
  props: {
    recipeGroupContentArea: {
      type: Array,
      default: () => []
    },
    trackingListName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      fixedSizes: {
        isMediumViewport: {
          size: "full"
        }
      },
      activeRecipeGroupIndex: 0
    }
  },
  computed: {
    activeRecipeGroup () {
      return this.recipeGroupContentArea[this.activeRecipeGroupIndex]
    }
  },
  methods: {
    openFolderModal (data) {
      this.$emit('open-folder-modal', data)
    },
    changeRecipeGroup (index) {
      this.activeRecipeGroupIndex = index

      dataLayer.add({
        event: 'recipeFilter',
        filter: this.activeRecipeGroup.title
      })
    }
  }
}
</script>

<style lang="scss">
.startpage-recipegroup {
  &__buttons {
    margin-bottom: 1rem;
  }

  &__button {
    margin-right: 0.5rem;
  }

  &__link {
    text-align: center;
    margin-top: 1rem;

    @include media-breakpoint-up (md) {
      margin-top: 1.5rem;
    }
  }
}
</style>
